import { useMemo } from 'react'
import { useData } from '@/contexts/data'
import { TimelineFilters, CurationFiltersUtils } from '@/types/filter'
import { FilterItem } from '../types'
import { parseFilterIds, resolveItemsByIds } from '../utils'

export function useFilterBreadcrumbData(filters: TimelineFilters | CurationFiltersUtils) {
  const {
    territories: allTerritories,
    contexts: allContexts,
    topics: allTopics,
    partners: allPartners,
    sources: allSources,
  } = useData()

  const ids = useMemo(() => parseFilterIds(filters), [filters])

  const territories = useMemo<FilterItem[]>(
    () => resolveItemsByIds(allTerritories, ids.territoryIds),
    [allTerritories, ids.territoryIds]
  )
  const contexts = useMemo<FilterItem[]>(
    () => resolveItemsByIds(allContexts, ids.contextIds),
    [allContexts, ids.contextIds]
  )
  const topics = useMemo<FilterItem[]>(
    () => resolveItemsByIds(allTopics, ids.topicIds),
    [allTopics, ids.topicIds]
  )
  const partners = useMemo<FilterItem[]>(
    () => resolveItemsByIds(allPartners, ids.partnerIds),
    [allPartners, ids.partnerIds]
  )
  const sources = useMemo<FilterItem[]>(
    () => resolveItemsByIds(allSources, ids.sourceIds),
    [allSources, ids.sourceIds]
  )

  const hasAnyFilter = useMemo(
    () =>
      territories.length > 0 ||
      contexts.length > 0 ||
      topics.length > 0 ||
      partners.length > 0 ||
      sources.length > 0 ||
      filters.favorited !== undefined ||
      filters.created_by !== undefined,
    [territories, contexts, topics, partners, sources, filters.favorited, filters.created_by]
  )

  return {
    territories,
    contexts,
    topics,
    partners,
    sources,
    hasAnyFilter,
  }
}
